import PasswordPage from '@/pages/auth/PasswordPage.tsx';
import {ReactElement} from 'react';

export default function PasswordResetPage(): ReactElement {
	return (
		<PasswordPage title="Reset Your Password" successMessage="Your password has been updated.">
			<p>
				Enter your new password below to finish resetting your password.
			</p>
		</PasswordPage>
	)
}
